module.exports = __webpack_public_path__ + "static/media/mdsign.7bf4d589.png";